/** Narration video-editor timeline lanes. Each one is fetched on its own. */
export const NARRATION_EDITOR_TIMELINE_LANES = [
  { lane: 'video', field: 'videoTracks' },
  { lane: 'audio', field: 'audioTracks' },
  { lane: 'music', field: 'musicTracks' },
  { lane: 'subtitles', field: 'subtitleTracks' },
  { lane: 'effects', field: 'effectTracks' },
  { lane: 'overlays', field: 'overlayTracks' },
];

export function editorSnapshotTracksFromLanes(rows) {
  const tracks = {};
  for (const row of rows || []) {
    if (!row?.field) continue;
    tracks[row.field] = Array.isArray(row.tracks) ? row.tracks : [[]];
  }
  return tracks;
}
